<template>
  <div class="admin-table-component">
    <table class="highlight">
      <thead>
        <tr>
          <th v-for="(col, index) in columns" :key="index">
            {{ resolveHeader(col.header) }}
          </th>
          <th />
        <tr v-if="buttons"></tr>
      </thead>
      <tbody>
        <div v-if="data.length === 0" class="p-2">
          {{ $store.state.user.langEng ? 'No entries available' : 'Inga värden tillgängliga' }}
        </div>
        <tr v-for="(entry, index) in data" :key="index" @click="rowClicked(entry)">
          <td 
            v-for="(col, innerIndex) in columns" 
            :key="innerIndex" 
            v-html="resolveColumn(col.value, entry)">
          </td>
          <td v-if="buttons" @click.stop> <!-- @click-stop to prevent row-click from firing -->
            <div class="right">
              <a class="btn-flat mr-1" @click="editClick(entry)">
                {{ $store.state.user.langEng ? 'Edit' : 'Redigera' }}
              </a>
              <a class="btn-flat" @click="deactivateClick(entry)">
                {{ 
                  entry.inactive ? 
                  $store.state.user.langEng ? 'Activate' : 'Aktivera' :
                  $store.state.user.langEng ? 'Deactivate' : 'Inaktivera' 
                }}
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AdminTable extends Vue {
  /** @type {AdminTableColumn[]} */
  @Prop() columns;

  /** @type {boolean} */
  @Prop() buttons;
  
  /** @type {any[]} */
  @Prop() data;

  resolveHeader(header) {
    if (typeof header === 'function') return header();
    else return header;
  }

  resolveColumn(value, entry) {
    if (typeof value === 'function') return value(entry);
    else return entry[value];
  }

  editClick(entry) {
    if (this.buttons)
      this.$emit('edit', entry);
  }

  deactivateClick(entry) {
    if (this.buttons)
      this.$emit('deactivate', entry);
  }

  rowClicked(entry) {
    this.$emit('row-click', entry);
  }

  created() {
  }
}

// Documentation

/**
 * @typedef AdminTableColumn
 * @property {string | function} header Value to use as this columns header
 * @property {string | function} value  Property name to use or function returning string to use.
 *                                      The function will be given the entry(data) for this column.
 */
</script>

<style scoped lang="scss">
.admin-table-component {
  $btn-color: #585858;

  .btn-flat {
    border: solid 1px $btn-color;
    color: $btn-color;
    font-weight: bold;
    text-transform: initial;

    &:hover {
      background-color: lightgray;
    }
  }
  
  table {
    background-color: white;
  }
}
</style>
